const CLEAR_CART_STATUS = 'CLEAR_CART_STATUS';
const FETCH_CART_STATUS_FULFILLED = 'FETCH_CART_STATUS_FULFILLED';
const FETCH_CART_STATUS_REJECTED = 'FETCH_CART_STATUS_REJECTED';
const FETCH_CART_STATUS = 'FETCH_CART_STATUS';
const REPLACE_CART_STATUS = 'REPLACE_CART_STATUS';
const ACTIONS_TO_SYNC = [
  FETCH_CART_STATUS_FULFILLED,
  FETCH_CART_STATUS_REJECTED,
  REPLACE_CART_STATUS,
  CLEAR_CART_STATUS,
];

export {
  ACTIONS_TO_SYNC,
  CLEAR_CART_STATUS,
  FETCH_CART_STATUS,
  FETCH_CART_STATUS_FULFILLED,
  FETCH_CART_STATUS_REJECTED,
  REPLACE_CART_STATUS,
};
